import StationModel from '../models/StationModel';
import BaseStore from './BaseStore';
import { action, computed } from 'mobx';
import * as api from '../actions/api';
import {observable, toJS} from "mobx/lib/mobx";

class StationStore extends BaseStore {

  @observable stationFullObservation = {
    station_id: '',
    data: [],
    parameters: []
  };

  constructor(transportLayer) {
    super(StationModel, transportLayer);
  }

  addDataOrigin(stationId, json) {
    return this.transportLayer.addDataOrigin(stationId, json)
      .then(action(data => {
        this.isLoading = false;
        this.updateItemFromServer(data, 'data_origin', stationId);
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'data_origin', json);
        // });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        throw new Error(err && err.message);
      }));
  }

  updateDataOrigin(id, dataOriginId, json) {
    return this.transportLayer.updateDataOrigin(id, dataOriginId, json);
  }

  removeDataOrigin(stationId, dataOriginId) {
    return this.transportLayer.removeDataOrigin(stationId, dataOriginId)
      .then(action(({ ids }) => {
        this.removeItemFromServer({ ids: [dataOriginId] }, 'data_origin', stationId);
      }));
  }

  _fetchObservations(stationId) {
    // console.log('StationStore _fetchObservations', stationId);
    return this.transportLayer.fetchObservations(stationId);
  }

  @action fetchField(itemId, field) {
    // console.log('xx');
    // if (this.isLoading) { return; } // TODO: Figure out better way of throttling
    const foundItem = this.findById(itemId);
    // console.log('field', field);
    // console.log('foundItem', foundItem.asJson);
    if (foundItem && foundItem[field]) { return; }

    if (field === 'observation') {
    // console.log('field', field);
      this.fetchObservations(itemId);
      // findObservations: (stationId) => get(`api/station/${stationId}/observation`),
    }
    this.fetchItem(itemId, true);
  }

  @action addDataSeries(stationId, json) {
    // this.isLoading = true;
    const body = {
      name: json.name,
      parameter_id: json.parameter_id,
      parameter_unit_id: json.parameter_unit_id,
      interval: json.interval,
      start_time: json.start_time,
      tolerance: json.tolerance,
      table: json.table,
    };

    return api.station.addDataSeries(stationId, body)
      .then((data) => {
        // this.isLoading = false;
        this.updateItemFromServer(data, 'data_series', stationId);
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'data_series', json);
        // });
        // return data;
      });
      // .catch(err => {
        // this.isLoading = false;
        // // console.log('err', err);
      // });
  }

  @action addAggregatedDataSeries(stationId, dataSeries, aggregation) {
    const dataSeriesBody = {
      name: dataSeries.name,
      parameter_id: dataSeries.parameter_id,
      parameter_unit_id: dataSeries.parameter_unit_id,
      interval: dataSeries.interval,
      start_time: dataSeries.start_time,
      tolerance: dataSeries.tolerance,
      table: dataSeries.table,
    };
    return api.station.addAggregatedDataSeries(stationId, {dataSeries: dataSeriesBody, aggregation})
      .then((data) => {
        this.updateItemFromServer(data, 'data_series', stationId);
      });
  }

  @action updateDataSeriesItem(stationId, dataSeriesId, json) {
    this.isLoading = true;
    const body = {
      name: json.name,
      parameter_id: json.parameter_id,
      parameter_unit_id: json.parameter_unit_id,
      interval: json.interval,
      start_time: json.start_time,
      tolerance: json.tolerance,
      table: json.table
    };

    return api.station.updateDataSeriesItem(stationId, dataSeriesId, body)
      .then((data) => {
        this.isLoading = false;
        this.updateItemFromServer(data, 'data_series', stationId);
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'data_series', json);
        // });
        // return data;
      })
      .catch(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      });
  }

  @action updateAggregatedDataSeriesItem(stationId, dataSeriesId, dataSeries, aggregation) {
    this.isLoading = true;
    const body = {
      name: dataSeries.name,
      parameter_id: dataSeries.parameter_id,
      parameter_unit_id: dataSeries.parameter_unit_id,
      interval: dataSeries.interval,
      start_time: dataSeries.start_time,
      tolerance: dataSeries.tolerance,
      table: dataSeries.table
    };
    return api.station.updateAggregatedDataSeriesItem(stationId, dataSeriesId, {dataSeries: body, aggregation})
      .then((data) => {
        this.isLoading = false;
        this.updateItemFromServer(data, 'data_series', stationId);
        // data.forEach(json => {
        // this.updateItemFieldFromServer(stationId, 'data_series', json);
        // });
        // return data;
      })
      .catch(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      });
  }

  @action removeDataSeriesItem(stationId, dataSeriesId) {
    this.isLoading = true;

    return api.station.removeDataSeriesItem(stationId, dataSeriesId)
      .then(action(({ ids }) => {
        this.isLoading = false;
        this.removeItemFromServer({ ids }, 'data_series', stationId);
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }

  @action fetchDataSeries(stationId, filters) {
    this.isLoading = true;
    return api.station.fetchDataSeries(stationId, filters)
      .then(action(data => {
        this.isLoading = false;
        this.updateItemFromServer(data, 'data_series', stationId);
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'data_series', json);
        // });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }

  @action fetchDataSeriesItem(stationId, dataSeriesId) {
    this.isLoading = true;
    return api.station.fetchDataSeriesItem(stationId, dataSeriesId)
      .then(action(data => {
        this.isLoading = false;
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'data_series', json);
        // });
        return data;
      }))
      .catch(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      });
  }

  @action fetchObservations(stationId) {
    this.isLoading = true;
    return api.station.fetchObservations(stationId)
      .then(action(data => {
        this.isLoading = false;
        data.forEach(json => {
          this.updateItemFieldFromServer(stationId, 'observation', json);
        });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }

  @action fetchMonitorings(stationId) {
    this.isLoading = true;
    return api.station.fetchMonitorings(stationId)
      .then(action(data => {
        // console.log('data', data);
        this.isLoading = false;
        this.updateItemFromServer(data.monitorings, 'monitoring', stationId);
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'data_origin', json);
        // });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }

  @action fetchDataOrigins(stationId) {
    this.isLoading = true;
    return api.station.fetchDataOrigins(stationId)
      .then(action(data => {
        this.isLoading = false;
        this.updateItemFromServer(data, 'data_origin', stationId);
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'data_origin', json);
        // });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }

  @action fetchDataOrigin(stationId, dataOriginId) {
    this.isLoading = true;
    return api.station.fetchDataOrigin(stationId, dataOriginId)
      .then(action(data => {
        this.isLoading = false;
        // data.forEach(json => {
          // // if (+json.id === +dataOriginId) {
          // this.updateItemFieldFromServer(stationId, 'data_origin', json);
          // // }
        // });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }


  @action fetchParameters(stationId) {
    this.isLoading = true;
    return api.station.fetchParameters(stationId)
      .then(action(data => {
        this.isLoading = false;
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'parameter', json);
        // });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }

  @action fetchMetaData(stationId) {
    this.isLoading = true;
    return api.station.fetchMetaData(stationId)
      .then(action(data => {
        this.isLoading = false;
        this.updateItemFromServer(data, 'meta_data', stationId);
        // data.forEach(json => {
          // this.updateItemFieldFromServer(stationId, 'meta_data', json);
        // });
        return data;
      }))
      .catch(action(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      }));
  }

  @action updateMetaData(stationId, json) {
    this.isLoading = true;
    const body = json;
    // const body = {
      // name: json.name,
      // parameter_id: json.parameter_id,
      // parameter_unit_id: json.parameter_unit_id,
      // interval: json.interval,
      // start_time: json.start_time,
      // tolerance: json.tolerance,
    // };

    return api.station.updateMetaData(stationId, body)
      .then(() => {
        this.isLoading = false;
      })
      .catch(err => {
        this.isLoading = false;
        // console.log('err', err);
        throw new Error(err && err.message);
      });
  }

  @action fetchQcChecks(stationId) {
    return api.station.fetchQcChecks(stationId);

    // this.isLoading = true;stationMe
    // return api.station.fetchQcChecks(stationId)
    //   .then(action(data => {
    //     // console.log('data', data);
    //     this.isLoading = false;
    //     // data.forEach(json => {
    //       // this.updateItemFieldFromServer(stationId, 'qc_checks', json);
    //     // });
    //     return data;
    //   }))
    //   .catch(action(err => {
    //     this.isLoading = false;
    //     // console.log('err', err);
    //     throw new Error(err && err.message);
    //   }));
  }

  @action saveQcChecks(stationId, json) {
    return api.station.saveQcChecks(stationId, json);
  }

  @action fetchFullObservations(filters){
    this.stationFullObservation = {
      station_id: filters.stations[0],
      data: [],
      parameters: []
    };
    this.isLoading = true;
    return api.analysis.fetchMore(filters).then(stations => {
      this.stationFullObservation.data = stations;
      this.stationFullObservation.parameters = stations[0].parameters ? stations[0].parameters.filter(item => !!item.data).map(item => ({id: item.parameter_id, parameter_name: item.parameter_name, parameter_code: item.parameter_code, unit: item.parameter_unit_symbol, show: true})) : [];
      this.isLoading = false;
      return Promise.resolve();
    }).catch(err => {
      this.isLoading = false;
      return Promise.reject(err);
    });
  }

  @action clearFullObservation() {
    this.stationFullObservation = null;
  }

  filterStations(stations, filterText){
    return stations.filter(station => (
      (station &&
        station.label &&
        station.label.toLowerCase().indexOf(filterText) !== -1) ||

      (station &&
        station.name &&
        station.name.toLowerCase().indexOf(filterText) !== -1) ||

      (station &&
        station.tags &&
        station.tags.reduce((acc, tag) => {
          if (tag.name.toLowerCase().indexOf(filterText) !== -1) {
            return true;
          }
          return acc;
        }, false))
    ))
  };
}

export default StationStore;



// WEBPACK FOOTER //
// ./src/stores/StationStore.js